import { useState, type ReactNode } from 'react';

import { Link } from '@/core/i18n/navigation';
import { envConfigs } from '@/config';

export interface NavLink {
  href: string;
  label: string;
  external?: boolean;
}
export function SiteHeader({
  navLinks = [],
  cta,
  menuLabels,
  language,
}: {
  navLinks?: NavLink[];
  cta?: NavLink;
  menuLabels: { open: string; close: string; main?: string; mobile?: string };
  language?: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return (
    <header className="crt-header">
      <div className="crt-container crt-header-row">
        <Link href="/" className="crt-brand">
          <img src="/logo-mark.svg" width="36" height="36" alt="" />
          <span>{envConfigs.app_name}</span>
        </Link>
        <nav aria-label={menuLabels.main || 'Main'} className="crt-desktop-nav">
          {navLinks.map((link) => (
            <Link key={link.href} href={link.href}>
              {link.label}
            </Link>
          ))}
        </nav>
        {language}
        {cta && (
          <Link href={cta.href} className="crt-button crt-desktop-cta">
            {cta.label} ↗
          </Link>
        )}
        <button
          type="button"
          className="crt-menu-button"
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? menuLabels.close : menuLabels.open}
        </button>
      </div>
      {open && (
        <nav
          id="mobile-navigation"
          aria-label={menuLabels.mobile || 'Mobile'}
          className="crt-mobile-nav crt-container"
        >
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          {cta && (
            <Link href={cta.href} onClick={() => setOpen(false)}>
              {cta.label}
            </Link>
          )}
        </nav>
      )}
    </header>
  );
}
